(function () {
  window.ScriptLoader = function () {
    /**
     * Promise-based script loader
     * @param {string} url
     * @param {object=} attr
     * @returns {Promise}
     */
    const loader = (url, attr) => new Promise((resolve, reject) => {
      const script = window.document.createElement('script');
      script.src = url;
      script.async = true;
      script.crossOrigin = 'anonymous';
      attr = attr || {};

      for (const attrName in attr) {
        script[attrName] = attr[attrName];
      }

      script.addEventListener('load', () => {
        resolve(script);
      }, false);

      script.addEventListener('error', () => {
        reject(script);
      }, false);

      window.document.body.appendChild(script);
    });

    /**
     * Loads scripts asynchronously
     * @param {string|string[]} urls
     * @param {object=} attr Other script tag attributes
     * @returns {Promise}
     */
    this.load = (urls, attr) => {
      if (!Array.isArray(urls)) {
        urls = [urls];
      }

      return Promise.all(urls.map(url => loader(url, attr)));
    }
  }

  if (window.jQuery) {
    init();
  } else {
    new window.ScriptLoader()
    .load([
      'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js'
    ])
    .then(() => {
      init();
    }, (error) => console.error('Failed to load script', error));
  }

  function init() {

    new window.ScriptLoader().load([
      'https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/jquery-minicolors/2.3.5/jquery.minicolors.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.2/dropzone.js',
      'https://cdnjs.cloudflare.com/ajax/libs/simplePagination.js/1.6/jquery.simplePagination.min.js'
    ]).then(() => {

      jQuery(document).ready(function ($) {

        // let host = 'http://localhost:8025';
        let host = 'https://api.vishion.co';
        let offset = 0;
        let filters = {};
        let tid = undefined;
        let cid = undefined;
        let filterArray = {};
        $.generateUUID = function () { // Public Domain/MIT
          let d = new Date().getTime(); // Timestamp
          let d2 = (performance && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16; // random number between 0 and 16
            if (d > 0) { // Use timestamp until depleted
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
            } else { // Use microseconds since page-load if supported
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
        }

        $.getClientId = function () {
          let key = 'client_id';
          let expiry = 365;
          let clientId = undefined;
          let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
          if (keyValue) {
            clientId = keyValue[2];
          } else {
            clientId = $.generateUUID();
            var expires = new Date();
            expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
            document.cookie = key + '=' + clientId + ';expires=' + expires.toUTCString();
          }
          return clientId;
        }

        $.productClick = function (productKey) {

          //     console.log('product clicked: ' + productKey);
          let params = {p: productKey};

          $.ajax({
            headers: {
              'X-Vishion-tid': tid,
              'X-Vishion-cid': cid
            },
            url: host + '/product/click',
            data: params
          });

        }

        // https://codepen.io/nakome/pen/nBKiF
        // https://www.cssscript.com/pick-a-color-from-an-image-using-canvas-and-javascript/
        function colorPickerFromImage() {

          var img = _('#uploadedImg'),
              canvas = _('#cs'),
              result = _('.result'),
              preview = _('.preview'), x = '', y = '';

          try {

            img.addEventListener('click', function (e) {
              if (e.offsetX) {
                x = e.offsetX;
                y = e.offsetY;
              } else if (e.layerX) {
                x = e.layerX;
                y = e.layerY;
              }
              useCanvas(canvas, img, function () {
                var p = canvas.getContext('2d')
                .getImageData(x, y, 1, 1).data;
                result.innerHTML = '<span>HEX: ' + rgbToHex(p[0], p[1], p[2]) + '</span>' +
                    '<span>RGB:  rgb(' +
                    p[0] + ',' +
                    p[1] + ',' +
                    p[2] + ')</span>';

                document.body.style.background = rgbToHex(p[0], p[1], p[2]);
                jQuery('#color').css('background', rgbToHex(p[0], p[1], p[2]));
                jQuery('#color-name').val(rgbToHex(p[0], p[1], p[2]));
                jQuery('#color').attr('data-selected-color', rgbToHex(p[0], p[1], p[2]));
              });
            }, false);

            img.addEventListener('dragstart', function (e) {
              e.preventDefault();
              if (e.offsetX) {
                x = e.offsetX;
                y = e.offsetY;
              } else if (e.layerX) {
                x = e.layerX;
                y = e.layerY;
              }
              jQuery('.preview.preview-color-icon').css('left', x + 'px');
              jQuery('.preview.preview-color-icon').css('top', y + 'px');

              useCanvas(canvas, img, function () {

                var p = canvas.getContext('2d')
                .getImageData(x, y, 1, 1).data;
                preview.style.background = rgbToHex(p[0], p[1], p[2]);
              });

            }, false);

            img.addEventListener('mousemove', function (e) {
              if (e.offsetX) {
                x = e.offsetX;
                y = e.offsetY;
              } else if (e.layerX) {
                x = e.layerX;
                y = e.layerY;
              }
              jQuery('.preview.preview-color-icon').css('left', x + 'px');
              jQuery('.preview.preview-color-icon').css('top', y + 'px');

              useCanvas(canvas, img, function () {

                var p = canvas.getContext('2d')
                .getImageData(x, y, 1, 1).data;
                preview.style.background = rgbToHex(p[0], p[1], p[2]);
              });
            }, false);
          } catch (e) {
            console.log(e)
          }

          function useCanvas(el, image, callback) {
            //     console.log(image.src);
            //     let img = new Image();
            //     img.src = image.src;
            //     console.log(img, 0, 0, image.width, image.height);
            el.width = image.width;
            el.height = image.height;
            el.getContext('2d')
            .drawImage(image, 0, 0, image.width, image.height);
            return callback();
          }

          function _(el) {
            return document.querySelector(el);
          };

          function componentToHex(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
          }

          function rgbToHex(r, g, b) {
            return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
          }

        }

        function filterCardItems(data) {
          let list = '';
          $.each(data, function () {
            if (this.type === 'range') {
              list += `<li>
                <a href="#" data-filter-selected="${this.selected}" data-filter-type="${this.type}" data-filter-name="${this.name}" 
                data-range-from="${this.from}" data-range-to="${this.to}"
                class="${this.selected ? 'active' : ''}">
                  <input class="checkbox" type="checkbox" ${this.selected ? 'checked' : ''}>
                  <span class="value">    ${this.label}</span>
                  <span class="amount ${this.count > 0 ? '' : 'hide-info'}">(${this.count})</span>
                </a>
              </li>`;
            } else if (this.type === 'value') {
              list += `<li>
                <a href="#" class="${this.selected ? 'active' : ''}" data-filter-selected="${this.selected}"
                data-filter-type="${this.type}" data-filter-name="${this.name}" data-filter-value="${this.value}">
                  <input class="checkbox" type="checkbox" ${this.selected ? 'checked' : ''}>
                  <span class="value">${this.label}</span>
                  <span class="amount ${this.count > 0 ? '' : 'hide-info'}">(${this.count})</span>
                </a>
              </li>`;
            }
          });
          return list;
        }

        function InitSearch(searchKeyword, selectedColor, offset, filters, sort) {

          // console.log('sort', sort);

          $('.loader-svg').show();

          let params = Object.assign({q: searchKeyword, hex: selectedColor, limit: 9, offset: offset}, filters);

          // console.log('params', params);
          let newParam = {value: searchKeyword};
          if (selectedColor) {
            newParam.color = selectedColor;
          }
          if (sort) {
            params['sort'] = sort;
          } else {
            delete params.sort;
          }
          if (history.pushState) {
            let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + $.param(params);
            console.log('newUrl', newUrl);
            window.history.pushState(null, '', newUrl);
          }

          cid = $.getClientId();
          let headers = {
            'X-Vishion-cid': cid
          };
          if (tid) {
            headers['X-Vishion-tid'] = tid
          }
          // headers['Authorization'] = 'Bearer eyJhbGciOiJSU0ExXzUiLCJlbmMiOiJBMjU2R0NNIn0.F_Oc1d_azSHIDfQdl3-SWLO8fdjpD8i7yHV_LzCZO0mrMXuyeCvyMrf6tpOYQKE4dteLI4K86H2S6EbXWTs-WMt9Hb-3zb4B9IY-d8x6IbiunPscmpJXAWF3DXMvi13dqlCbatBp-cdXgs2E3fcJJ4iTCZHPCXvD21OUecx1SgRfNOt8JHKcUsvRz3h4ZG4yoebNeOpBmqkon090jtV2ilSZvIIYBpw50UwFcy28ePih4ZaTI2YboLgceVm03pAPZs-eBdFkexodEoS6WxRS6hkqMgKTQQWgAcNSwtlw5fW16AkVT23UOQXA5QFXqfYu0MeDKRHZ4tbHK3Eu0eqEcg._hLknwplqEAbMnhN.PmqQPnMJaBIIvJYcPI9DTsXCpx8NcwMDf3pP2NY-f9RswtKstunYQZW1UD_TUwGJ0EOZPhYqyS9lm__eDFRS8RYZ_A7tcjqgXgi7UryUciAODbdltWrNw3B4pGfx3aUsFDylzspG4VNxXchjefD-GsU5s2jNKp9zXL0vQjxJGCU5UwwY5u2zDW6cX9a21qNWoeBDL_rulITkT6O4_OlMk7zZfR9GA3QGlIengkQL1qZsO1gQdSfzeD0ETbo1bTV1m1OLLlBrYC_MIxcMyrRpIgPdwiYDghiPN3iNL1mSXZ4PeXjhwoJVUd1IYpejtgNh7hI_F5sI7oDJfgTtnWWu0Pe8utCdVnooPNWZCurNyyg94hVF4_jIQFAcLSWjugrwS1Uyduht2idAmZENLd8-GX1-ncv3H7JtkcrsWLgj592GVd0xfcA3COlE0AvkAAA74Xd-hzfVuOfYh8O00pOJhNN7iOGWrRw5v3UGJtsn8Nwq8FURLD3gykSCQIHGCt-s4qUeBNo4pEYKflSuQ_Aie0eZ4wWsuOevQnWBbrCzhHeROe58IBvWRgILaFSwFSXmXIwFa3RhwS4uqwaEk_JkxYOR0a1Oo7WX09r8Z7R9jjZpZ5opAxXJP5lv91lhDQjTQLpFy-c3YpTQEaM9wTaI9Lxji1KiLQ5Lk_2exPs.5AwvIu2yTN1tjaiZeyAQ-g';

          if (selectedColor === 'Q') {
            delete params.hex;
            delete newParam.color;
          }

          // console.log('params', params)
          $.ajax({
            headers: headers,
            url: host + '/product/search',
            data: params
          })
          .done(function (data, status, xhr) {

            $('.loader-svg').hide();

            tid = xhr.getResponseHeader('X-Vishion-tid');

            let filterCard = '';

            let sortOption = '<select name="sort" class="sort">'
            Object.keys(data.sortOptions).forEach((key) => {
              let item = data.sortOptions[key];
              sortOption += `<option value="${item.value}" ${item.selected ? 'selected' : ''}>${item.label}</option>`

            });

            sortOption += '</select>'

            let sortingCard = `<div class="filterCard SortOptions">
              <button><h4>Sort By</h4></button>
              <div class="items">
              <ul><li>
              ${sortOption}
              </li>
              </ul>
              </div>
              </div><hr style="margin: 5px;"`;
            filterCard += sortingCard;

            $('.sort-mob').html(sortingCard);

            Object.keys(data.filters).forEach(key => {
              console.log(key, data.filters[key]);
              if (data.filters[key] && data.filters[key].length) {
                filterCard += `<div class="filterCard ${key}">
                  <button><h4>${key}</h4></button>
                  <div class="items">
                  <ul>
                  ${filterCardItems(data.filters[key])}
                  
                  </ul>
                  </div>
                  </div><hr style="margin: 5px;">`;
              }
            });
            $('.filters-wrapper').html(filterCard);

            $('#pagination').pagination({
              items: data.hits.totalElements,
              itemsOnPage: data.hits.numberOfElements,
              cssStyle: 'light-theme',
              currentPage: offset + 1,
              onPageClick: function (pageNumber) {
                // console.log(pageNumber);
                // $('#pagination').pagination('selectPage', pageNumber);
                InitSearch(searchKeyword, selectedColor, pageNumber - 1, filters, sort);

              }
            });

            $('.show_products').empty();
            $('.search_page').show();

            $('ul#live_search_result').empty();
            //         $('ul#content').empty().addClass('active');

            $('#queryMillis').text(data.timing.queryMillis);
            $('#totalMillis').text(data.timing.totalMillis);

            let displaySettings = data.displaySettings;
            let i = 0;
            let qItem = '';
            let products = [];

            $.each(data.hits.content, function () {

              if (selectedColor === 'Q' && i < 4) {
                qItem += `<a class="quick-search__result quick-search__result__custom" href="${this.product.previewUrl}">
                      <div class="quick-search__result-image">
                        <img class="image__img ls-is-cached lazyloaded" 
                        data-src="${this.product.images[0].src}" 
                        src="${this.product.images[0].src}">
                      </div>
                      <div class="quick-search__result-details ff-body fs-body-base">
                        <div class="quick-search__result-heading">${this.product.title}</div>
                        <div class="quick-search__result-subheading">${this.product.minVariantPrice.formatted}</div>
                      </div>
                    </a>`;
              }
              i++;

              let product = `<div class="product">
                    <a href="${this.product.previewUrl}" class="hover" onclick="$.productClick('${this.product.productKey}')">
                      <img src="${this.product.images[0].src}" alt="${this.product.title}" class="product_img">
                    </a>
                    <div class="product_detail product_title">
                      <a href="${this.product.previewUrl}" class="h4 hover product-card__title" onclick="$.productClick('${this.product.productKey}')">${this.product.title}</a></div>
                    <div class="product_detail color ${displaySettings.showColors ? '' : 'hide-info'}">`;

              $.each(this.product.images[0].rgbcolors, function() {
                product += `<div style="background-color: ${this}"> </div>`;
              });

              product += `</div>
                    <div class="product_detail h5 product_vendor ${displaySettings.showVendor ? '' : 'hide-info'}">${this.product.vendor}</div>
                    <div class="product_detail h5 product_type ${displaySettings.showProductType ? '' : 'hide-info'}">${this.product.productType}</div>                      
                    <div class="product_detail product_description ${displaySettings.showDescription ? '' : 'hide-info'}">${this.product.description}</div>                
                    <div class="product_detail h5 product_price ${displaySettings.showPrices ? '' : 'hide-info'}">Price: ${this.product.minVariantPrice.formatted}</div>
                  </div>`;

              products.push(product);
            });

            $('.show_products').append(products.join(" "));

            if (selectedColor === 'Q') {
              let qHeader = `<div class="quick-search__header ff-meta fs-meta">Products</div>`;

              let viewAll = `<div class="quick-search__view-all ff-body fs-body-base"><button type="submit">View all</button></div>`;

              $('.quick-search__results').addClass('visible');

              $('.quick-search__results').html(qHeader + qItem + viewAll);

              $('.quick-search__results').attr('style', 'display: block; opacity: 1 !important;');

            }

          }, "json");
        }

        function showDiv(idInfo) {
          $('.divlink-container').hide();
          $('#container' + idInfo).show();

          if (idInfo === '2') {
            // color palatte
            //$.minicolors.defaults.inline = true;
            $('.color_palette_picker').minicolors({
              inline: true,
              change: function (value, opacity) {
                // console.log(value + ' - ' + opacity);
                $('#color-name').val(value);
                $('#color').attr('data-selected-color', value);
                $('#color').css('background-color', value);
              }
            });
          }

          if (idInfo === '4') {

            // reference https://jsfiddle.net/zm54nob1/9/
            var myDropzone = new Dropzone("#my-dropzone", {

              url: host + '/product/image/upload',
              acceptedFiles: 'image/*',
              maxFileSize: 250,
              uploadMultiple: false,
              // previewsContainer: "#dropzone-previews",
              success: function (file, response) {
                var imgName = response;
                file.previewElement.classList.add("dz-success");
                console.log("Successfully uploaded :", imgName, file);
                // $('#uploadedImg').attr('src', response.externalUrl);

                $('#uploadedImg').attr('src', file.dataURL);

                $('#uploadedImgWrap').show();
              },
              error: function (file, response) {
                file.previewElement.classList.add("dz-error");
              }

            });
            myDropzone.on("addedfile", function (file) {
              /* Maybe display some more file information on your page */
              $('.the-progress').show();
              // $('#my-dropzone').hide();
            });

            myDropzone.on("totaluploadprogress", function (progress) {
              if (progress === 100) {
                $('.the-progress').hide();
              }
              console.log(progress);
              $("#the-progress-div").width(Math.round(progress) + '%');
              $(".the-progress-text").text(Math.round(progress) + '%');
            });

            myDropzone.on("complete", function (file) {
              this.removeAllFiles(true);
              $('#my-dropzone').hide();
              $('.btnUploadMore').show();
            });

            $('body').on('click', '.btnUploadMore', function ($event) {
              $('#uploadedImg').attr('src', '');
              $('#my-dropzone').show();
              $('#uploadedImgWrap').hide();
              $('.btnUploadMore').hide();
            });
          }

        }

        $('#Search').on('keypress', function (e) {
          var key = e.which;
          if (key == 13)  // the enter key code
          {
            var selectedColor = jQuery('[data-current-color]').attr('data-current-color');
            selectedColor = selectedColor.replace("#", "");
            var searchKeyword = $(this).val();
            filters = {};
            InitSearch(searchKeyword, selectedColor, offset, filters);
          }
        });

        $('.quick-search__input').on('keyup', function (e) {

          var searchKeyword = $(this).val();
          filters = {};
          InitSearch(searchKeyword, 'Q', offset, filters);

        });

        $('#SearchBtn').on('click', function () {
          var selectedColor = jQuery('[data-current-color]').attr('data-current-color');
          selectedColor = selectedColor.replace("#", "");
          var searchKeyword = $('#Search').val();
          filters = {};
          InitSearch(searchKeyword, selectedColor, offset, filters);
        });

        $('body').on('click', "a[data-filter-name]", function ($event) {
          $event.preventDefault();

          let selectedColor = jQuery('[data-current-color]').attr('data-current-color');
          selectedColor = selectedColor.replace("#", "")
          let searchKeyword = $('#Search').val();

          let type = $(this).attr('data-filter-type');
          let name = $(this).attr('data-filter-name')
          let value = $(this).attr('data-filter-value');
          let filter = `filter.${name}`;

          let isChecked = $(this).find('.checkbox').is(":checked");
          let selected = $(this).attr('data-filter-selected');
          console.log('filter selected', isChecked, JSON.parse(selected));

          if (isChecked && JSON.parse(selected)) {
            $(this).removeClass('active');
            $(this).find('.checkbox').prop('checked', false);
            if (type === 'range') {
              let filterFrom = `${filter}.from`;
              delete filters[filterFrom];
              let filterTo = `${filter}.to`;
              delete filters[filterTo];
            } else if (type === 'value') {
              console.log('filters', filters);
              console.log('filterArray', filterArray);
              if (filterArray[name] && filterArray[name].length) {
                const index = filterArray[name].indexOf(value);
                if (index > -1) {
                  filterArray[name].splice(index, 1);
                }
                filters[filter] = filterArray[name].toString();
              }

              if (filterArray[name] && filterArray[name].length === 0) {
                delete filters[filter];
              }

              //         if (filters[filter]) {
              //           console.log(filters[filter], filter);
              //           filters[filter] = filters[filter].replace(value, '');
              //           //           if (filters[filter] === filters[filter].replace(value, '')) {
              //           //             delete filters[filter];
              //           //           } else {
              //           //             filters[filter] = filters[filter].replace(value, '');
              //           //           }
              //         }

            }
          } else {
            $(this).addClass('active');
            $(this).find('.checkbox').prop('checked', true);
            if (type === 'range') {
              let rangeFrom = $(this).attr('data-range-from');
              let rangeTo = $(this).attr('data-range-to');
              // console.log(priceFrom, priceTo);
              if (rangeFrom !== 'null') {
                let filterFrom = `${filter}.from`;
                filters[filterFrom] = rangeFrom;
              } else if (rangeFrom === 'null') {
                let filterFrom = `${filter}.from`;
                delete filters[filterFrom];
              }
              if (rangeTo !== 'null') {
                let filterTo = `${filter}.to`;
                filters[filterTo] = rangeTo;
              } else if (rangeTo === 'null') {
                let filterTo = `${filter}.to`;
                delete filters[filterTo];
              }
            } else if (type === 'value') {
              // console.log('test', filters, filters[filter], value);
              if (filterArray[name] && filterArray[name].length) {

              } else {
                filterArray[name] = [];
              }
              filterArray[name].push(value);
              filters[filter] = filterArray[name].toString();
            }
          }
          let sortValue = $('select.sort').val();
          console.log('filters in search', filterArray, filters);
          InitSearch(searchKeyword, selectedColor, offset, filters, sortValue);
        });

        $('.open-modal').click(function (event) {
          let selectedColor = jQuery('[data-current-color]').attr('data-current-color');
          if (selectedColor) {
            $('#color-name').val(selectedColor);
            $('#color').attr('data-selected-color', selectedColor);
            $('#color').css('background-color', selectedColor);
          } else {
            $('#color-name').val('#000000');
            $('#color').attr('data-selected-color', '');
            $('#color').css('background-color', '#000000');
          }
          $('#ex1').modal({
            fadeDuration: 250,
            fadeDelay: 0.80
          });
          showDiv('2');
          return false;
        });

        $('body').on('click', '.option-tab li a', function ($event) {
          $event.preventDefault();
          $('.option-tab li a').removeClass('active');
          $(this).addClass('active');
          let tabIndex = $(this).attr('data-tab');
          showDiv(tabIndex);

        });

        $('body').on('click', '.btn-close-modal', function ($event) {
          $.modal.close();
        });

        $('body').on('click', '.option-tab li a', function ($event) {
          $event.preventDefault();
        });

        $('body').on('click', '.btn-select-color', function () {
          let selectedColor = $('#color').attr('data-selected-color');
          jQuery('[data-current-color]').attr('data-current-color', selectedColor);
          jQuery('[data-current-color]').css('background', selectedColor);
          if (selectedColor) {
            $('.btn-clear-color').show();
            $('[data-current-color]').addClass('data-current-color-present');
          }
          // console.log(selectedColor);
          $.modal.close();
          let searchKeyword = $('#Search').val();
          if (searchKeyword && selectedColor) {
            let newColor = selectedColor.replace("#", "");
            InitSearch(searchKeyword, newColor, offset, filters);
          }

        });

        $('body').on('click', '.btn-clear-color', function ($event) {
          $event.stopPropagation();
          jQuery('[data-current-color]').attr('data-current-color', '');
          jQuery('[data-current-color]').css('background', '');
          $('.btn-clear-color').hide();
          let searchKeyword = $('#Search').val();
          InitSearch(searchKeyword, '', offset);

        });

        Dropzone.autoDiscover = false;

        colorPickerFromImage();

        $('body').on('change', 'select.sort', function () {
          // console.log(this.value);

          InitSearch(params.value, params.color, offset, params.filters, this.value);

        });

        $('body').on('click', '#filterToggle', function () {
          $('.filters').toggleClass('show');
          $('.filtersOverlay').toggleClass('show');
        });

        $('body').on('click', '.filtersOverlay.show', function () {
          $('.filtersOverlay.show').removeClass('show');
          $('.filters').toggleClass('show');
        });

        $('body').on('click', '#quick-color-pick', function () {
          let ur = "/search" + window.location.search;
          ur = ur.replace('&color=Q', '');
          window.location.href = ur;
          sessionStorage.setItem("quickColor", "pick");
        });

        // Auto search on page load

        let quickColor = sessionStorage.getItem("quickColor");

        if (quickColor === 'pick') {
          $('#btn-color').click();
          sessionStorage.removeItem("quickColor");
        } else {

          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          console.log('auto search: ' + params)

          if (params && params.q) {
            params.value = params.q;
            delete params.q;
          }

          $('#Search').val(params.value);

          if (params.color) {
            $('[data-current-color]').attr('data-current-color', '#' + params.color);
            $('[data-current-color]').css('background', '#' + params.color);
            $('.btn-clear-color').show();
            $('[data-current-color]').addClass('data-current-color-present');
          }

          InitSearch(params.value, params.color, offset, params.filters, params.sort);
        }

      });
    }, (error) => console.error('Failed to load script', error));
  }
})();
